module.exports = __webpack_public_path__ + "static/media/schoolBG.93ffcb10.png";